/*http://www.cssscript.com/fullscreen-morphing-search-field-with-javascript-and-css3/
 */
(function () {
	var $searchOverlay = document.querySelector(".search-overlay");
	var $search = document.querySelector(".search_mag");
	var $search_again = document.querySelector(".search_again");
	var $clone, offsetX, offsetY;

	$search.addEventListener("click", loadForm, false);
	if ($search_again) $search_again.addEventListener("click", loadForm, false);

	function loadForm() {
		var $original = $search;
		$clone = $search.cloneNode(true);

		$searchOverlay.classList.add("s--active");

		$clone.classList.add("s--cloned", "s--hidden");
		$searchOverlay.appendChild($clone);

		var triggerLayout = $searchOverlay.offsetTop;

		var originalRect = $original.getBoundingClientRect();
		var cloneRect = $clone.getBoundingClientRect();

		offsetX = originalRect.left - cloneRect.left;
		offsetY = originalRect.top - cloneRect.top;

		$clone.style.transform = "translate(" + offsetX + "px, " + offsetY + "px)";
		$original.classList.add("s--hidden");
		$clone.classList.remove("s--hidden");

		var triggerLayout = $searchOverlay.offsetTop;

		$clone.classList.add("s--moving");

		$clone.setAttribute("style", "");

		$clone.addEventListener("transitionend", openAfterMove);
	}

	function openAfterMove() {
		$clone.classList.add("s--active");
		$clone.querySelector("input").focus();

		addCloseHandler($clone);
		addCloseHandlerBg($clone);
		$clone.removeEventListener("transitionend", openAfterMove);
	}

	function addCloseHandler($parent) {
		var $closeBtn = $parent.querySelector(".search__close");
		$closeBtn.addEventListener("click", closeHandler);
	}

	function addCloseHandlerBg($parent) {
		var $closeBtn = $parent.querySelector(".search__bg");
		$closeBtn.addEventListener("click", closeHandler);
	}

	/* close handler functions */
	function closeHandler(e) {
		$clone.classList.remove("s--active");
		e.stopPropagation();

		var $cloneBg = $clone.querySelector(".search__bg");

		$cloneBg.addEventListener("transitionend", moveAfterClose);
	}

	function moveAfterClose(e) {
		e.stopPropagation(); // prevents from double transitionend even fire on parent $clone

		$clone.classList.add("s--moving");
		$clone.style.transform = "translate(" + offsetX + "px, " + offsetY + "px)";
		$clone.addEventListener("transitionend", terminateSearch);
	}

	function terminateSearch(e) {
		$search.classList.remove("s--hidden");
		$clone.remove();
		$searchOverlay.classList.remove("s--active");
	}
})();
